import React from 'react';
import { Button } from '@/shared/ui/button';

interface CTAButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  onClick?: () => void;
  children: React.ReactNode;
  className?: string;
  fullWidthMobile?: boolean;
}

const CTAButton = React.forwardRef<HTMLButtonElement, CTAButtonProps>(
  ({ onClick, children, className = '', fullWidthMobile = true, ...props }, ref) => {
    const widthClass = fullWidthMobile ? 'w-full sm:w-auto' : '';

    return (
      <Button
        ref={ref}
        onClick={onClick}
        className={`bg-maintenance-navy text-white hover:bg-maintenance-blue border border-white/30 hover:border-white transition-colors px-6 md:px-8 py-2 md:py-3 text-base md:text-lg ${widthClass} ${className}`}
        {...props}
      >
        {children}
      </Button>
    );
  }
);

CTAButton.displayName = 'CTAButton';

export default CTAButton;
